import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex items-center gap-3.5',
    imageWrapper: 'relative size-15 shrink-0 sm:size-20 md:size-25',
    image: 'object-cover',
    info: 'flex flex-col gap-2.5 sm:gap-3',
    title: 'heading-xs-bold md:heading-s-bold sm:heading-m-bold',
    tags: 'flex h-6 gap-1',
    tag: 'heading-xs rounded-full px-2 py-0.5'
  },
  variants: {
    color: {
      primary: {
        base: 'bg-white',
        tag: 'bg-bg-items-white'
      },
      secondary: {
        base: 'bg-bg-items-white',
        tag: 'bg-white'
      }
    }
  }
});
